import React, { useEffect, useState } from "react";
import {
  ButtonGroup,
  Pagination,
  Stack,
  Button,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog,
  Skeleton,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Typography,
  Drawer,
} from "@mui/material";
import { toast } from "react-toastify";
import Nodata from "../../Assets/images/svg/Data-unavailable.svg";
import SupervisorContactfilter from "./SupervisorContact-filter";
import "../SupervisorContact/supervisor.css";
import { RiErrorWarningLine } from "react-icons/ri";
import axios from "axios";
import { BaseUrl, excelDownloadUrl } from "../../Container/BaseUrl/BaseUrl";
import moment from "moment";
import { MdOutlineFileUpload } from "react-icons/md";
import SupervisorAgentreports from "./SupervisorContact-Agentreports";
import { toaststyle } from "../../Utils/toaststyle";
import { DownloadSimple, FunnelSimple, Trash } from "@phosphor-icons/react";
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import {
  StyledPaper,
  StyledTableContainer,
  StyledTable,
  StyledTableHead,
  StyledTableBody,
  StyledTableRow,
  StyledTableCell,
  StyledTableCell2,
} from "../../CustomComponent/TableCompoent";
import { TiWarningOutline } from "react-icons/ti";
import { Hourglass } from "react-loader-spinner";
import { connect } from "react-redux";
import {
  getAvailableAgentList,
  setChatType,
} from "../../Redux/Actions/actions";

const mapStateToProps = (state) => {
  return {
    DropDownAgentList: state.contactListData.DropDownAgentList,
  };
};
const SupervisorContact = (props) => {
  const agent = JSON.parse(localStorage.getItem("tokenAgent"));
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];

  const isToDateValid = () => {
    return !todate || !fromdate || new Date(todate) >= new Date(fromdate);
  };

  const [showSupervisorfilter, setShowSupervisorfilter] = useState(false);
  const [showSupervisorAgentreports, setShowSupervisorAgentreports] =
    useState(false);
  const [SupervisorAgentName, setSupervisorAgentName] = useState([]);
  const [Agentid, setAgentid] = useState();
  const [fromdate, setFromdate] = useState(defaultValue);
  const [todate, setTodate] = useState(defaultValue);
  const [fileuploadPopup, setfileuploadPopup] = useState(false);
  const [ServiceButton, setServiceButton] = useState("contained");
  const [SalesButton, setSalesButton] = useState("outlined");
  const [agentButton, setagentButton] = useState("outlined");
  const [smsButton, setSmsButton] = useState("outlined");

  const [pagination, setPagination] = useState(0); //service
  const [page, setPage] = useState(1);
  const [pagination2, setPagination2] = useState(0); //sales
  const [page2, setPage2] = useState(1);
  const [pagination3, setPagination3] = useState(0); //agent
  const [page3, setPage3] = useState(1);
  const [pagination4, setPagination4] = useState(0); //SMS count
  const [page4, setPage4] = useState(1);

  const [supervisorSalesContactList, setsupervisorSalesContactList] = useState(
    []
  );
  const [supervisorServiceContactList, setsupervisorServiceContactList] =
    useState([]);
  const [agentCount, setagentCount] = useState([]);
  const [smsCountContactList, setSmsCountContactList] = useState([]);
  const [mobilenumber, setmobilenumber] = useState("");
  const [tableType, settableType] = useState("Service");
  const [filterType, setfilterType] = useState("");
  const [file, setfile] = useState();
  const [loadingSales, setLoadingSales] = useState(false);
  const [loadingService, setLoadingService] = useState(false);
  const [loadingAgent, setLoadingAgent] = useState(false);
  const [loadingSmsCount, setLoadingSmsCount] = useState(false);

  const [spinner, setSpinner] = useState(false);
  const [Salespreview, setSalesPreview] = useState(false);
  const [Servicepreview, setServicePreview] = useState(false);
  const [selectedSalesfile, setSelectedSalesfile] = useState(false);
  const [selectedServicefile, setSelectedServicefile] = useState(false);
  const [totalCountPreview, setTotalCountPreview] = useState(false);
  const [totalErrorCount, setTotalErrorCount] = useState();
  const [errorFile, setErrorFile] = useState("");
  const [totalSuccessCount, setTotalSuccessCount] = useState();
  const [tableListType, settableListType] = useState("serviceUpload");

  const [selectedAgents, setSelectedAgents] = useState([]);
  const [uploadButton, setUploadButton] = useState(true);
  const [uploadButton2, setUploadButton2] = useState(true);

  //Service Select

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRowIds, setSelectedRowIds] = useState([]);

  const [selectedRowsByPage, setSelectedRowsByPage] = useState({});
  const [selectAllByPage, setSelectAllByPage] = useState({});

  //Sales Select

  const [selectedRowssales, setSelectedRowssales] = useState([]);
  const [selectAllsales, setSelectAllsales] = useState(false);
  const [selectedRowIdssales, setSelectedRowIdssales] = useState([]);


  const [selectedRowsByPagesales, setSelectedRowsByPagesales] = useState({});
  const [selectAllByPagesales, setSelectAllByPagesales] = useState({});

  //Service Select





  const handleRowSelect = (rowData) => {
    setSelectedRowIds((prevSelectedRowIds) => {
      if (prevSelectedRowIds.includes(rowData.id)) {
        return prevSelectedRowIds.filter(id => id !== rowData.id);
      } else {
        return [...prevSelectedRowIds, rowData.id];
      }
    });

    setSelectedRowsByPage(prev => {
      const pageSelectedRows = prev[page] || [];
      if (pageSelectedRows.includes(rowData.id)) {
        return {
          ...prev,
          [page]: pageSelectedRows.filter(id => id !== rowData.id)
        };
      } else {
        return {
          ...prev,
          [page]: [...pageSelectedRows, rowData.id]
        };
      }
    });
  };

  
  

  const handleSelectAll = () => {
    const pageRows = supervisorServiceContactList.map(row => row.id);
    console.log('pageRows',pageRows)
    if (selectAll) {
      setSelectedRowsByPage(prev => ({
        ...prev,
        [page]: []
      }));
    } else {
      setSelectedRowsByPage(prev => ({
        ...prev,
        [page]: pageRows
      }));
    }
  
    setSelectAllByPage(prev => ({
      ...prev,
      [page]: !selectAll
    }));
    setSelectAll(!selectAll);
  };
  
  

  const handleDelete = async (rowData) => {
    const selectedRowsForPage = selectedRowsByPage[page] || [];
  
    // if (selectedRowsForPage.includes(rowData.id)) {
      console.log("Deleting row with id:", rowData.id);
  
      let data = {
        type: tableType ? tableType.toLocaleLowerCase() : '',
        contactid: rowData.id,
      };
  
      await axios
        .post(BaseUrl + "/contact/deletesalesservice", data, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        })
        .then((res) => {
          console.log("listServicereport", res);
          if (res.data.status === true) {
            // Refresh the service report after deletion
            listServicereport();
            setSelectedRowIds([])
            setSelectedRowsByPage({})
            toast.success(res.data.message)

          }else{
            setSelectedRowIds([])
            setSelectedRowsByPage({})
            toast.success(res.data.message)

          }
        })
        .catch((error) => {
          toast.success(res.data.message)
          console.error("Error during deletion:", error);
        });
    // } 
    // else {
    //   console.log("Row not selected, deletion not performed.");
    // }
  };


  const handleDeleteAll = async () => {
    const pageRows = supervisorServiceContactList.map(row => row.id);
    console.log('pageRowspageRowspageRows',pageRows)
    // if (selectAll) {
      let data = {
        type: tableType ? tableType.toLocaleLowerCase() : '',
        // contactid: selectedRowIds?selectedRowIds:pageRows,
        contactid:selectAll?pageRows:selectedRowIds
      };
  
      await axios
        .post(BaseUrl + "/contact/deletebulksalesservice", data, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        })
        .then((res) => {
          console.log("listServicereport", res);
          if (res.data.status === true) {
            setSelectAll(false)
            listServicereport();
            setSelectedRowIds([])
            setSelectedRowsByPage({})
            setSelectAllByPage({})
            toast.success(res.data.message)
          }else{
            setSelectAll(false)
            setSelectedRowIds([])
            toast.success(res.data.message)

          }
        })
        .catch((error) => {
          toast.success(res.data.message)
          setSelectAll(false)
          setSelectedRowIds([])
          console.error("Error during deletion:", error);
        });
    // } 
    // else {
    //   console.log("Row not selected, deletion not performed.");
    // }
  };
  


  //Sales Select


  const handleRowSelectsales = (rowData) => {

    setSelectedRowIdssales((prevSelectedRowIds) => {
      if (prevSelectedRowIds.includes(rowData.id)) {
        return prevSelectedRowIds.filter(id => id !== rowData.id);
      } else {
        return [...prevSelectedRowIds, rowData.id];
      }
    });

    setSelectedRowsByPagesales(prev => {
      const pageSelectedRows = prev[page2] || [];
      if (pageSelectedRows.includes(rowData.id)) {
        return {
          ...prev,
          [page2]: pageSelectedRows.filter(id => id !== rowData.id)
        };
      } else {
        return {
          ...prev,
          [page2]: [...pageSelectedRows, rowData.id]
        };
      }
    });



    // setSelectedRowsByPagesales(prev => {
    //   const pageSelectedRows = prev[page2] || [];
    //   if (pageSelectedRows.includes(rowData.id)) {
    //     // Deselect the row
    //     return {
    //       ...prev,
    //       [page2]: pageSelectedRows.filter(id => id !== rowData.id)
    //     };
    //   } else {
    //     // Select the row
    //     return {
    //       ...prev,
    //       [page2]: [...pageSelectedRows, rowData.id]
    //     };
    //   }
    // });
  };
  

  const handleSelectAllsales = () => {
    const pageRows = supervisorSalesContactList.map(row => row.id);
    
    if (selectAllsales) {
      setSelectedRowsByPagesales(prev => ({
        ...prev,
        [page2]: []
      }));
    } else {
      setSelectedRowsByPagesales(prev => ({
        ...prev,
        [page2]: pageRows
      }));
    }
  
    setSelectAllByPagesales(prev => ({
      ...prev,
      [page2]: !selectAllsales
    }));
    setSelectAllsales(!selectAllsales);
  };





  const handleDeletesales = async(rowData) => {
    console.log("Deleted row with id:", rowData);
    setLoadingSales(true);
    let data = {
      type:tableType?tableType.toLocaleLowerCase():'',
      contactid:rowData.id
    };
    await axios
      .post(BaseUrl + "/contact/deletesalesservice", data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        console.log("listServicereport", res);
        if (res.data.status == true) {
          listSalesreport()
          toast.success(res.data.message)
        } else{
          toast.success(res.data.message)
        }
      })
      .catch((error) => {
       console.log(error)
      });

  };


    const handleDeleteAllsales = async () => {
    const pageRows = supervisorSalesContactList.map(row => row.id);
    console.log('pageRowspageRowspageRows',pageRows)
    // if (selectAllsales) {
      let data = {
        type: tableType ? tableType.toLocaleLowerCase() : '',
        contactid: selectAllsales?pageRows:selectedRowIdssales,
      };
  
      await axios
        .post(BaseUrl + "/contact/deletebulksalesservice", data, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        })
        .then((res) => {
          console.log("listServicereport", res);
          if (res.data.status === true) {
            listSalesreport();
            setSelectAllsales(false)
            setSelectedRowIdssales([])
                setSelectedRowsByPagesales({})
            setSelectAllByPagesales({})
            toast.success(res.data.message)
          }else{
          setSelectAllsales(false)
          setSelectedRowIdssales([])
          toast.success(res.data.message)
          }
        })
        .catch((error) => {
        setSelectAllsales(false)
        setSelectedRowIdssales([])
          console.error("Error during deletion:", error);
          toast.success(res.data.message)
        });
    // } else {
    //   console.log("Row not selected, deletion not performed.");
    // }
  };

  //Sales Select

  const [brand, setBrand] = useState("");
  const clearFilterCache = () => {
    setFromdate(defaultValue);
    setTodate(defaultValue);
    setmobilenumber("");
    setSupervisorAgentName("");
  };

  const clearFilter = () => {
    setFromdate("");
    setTodate("");
    setmobilenumber("");
    setSupervisorAgentName("");
  };

  const hiddenFileInput = React.useRef(null);
  const hiddenFileInput2 = React.useRef(null);

  const ServicehandleClick = (event) => {
    hiddenFileInput.current.click();
  };
  const SaleshandleClick2 = (event) => {
    hiddenFileInput2.current.click();
  };
  const handleClose = () => {
    setfileuploadPopup(false);
  };

  const handleClosePreview = () => {
    setSalesPreview(false);
    setSelectedSalesfile(null);
    setSelectedAgents([]);
    if (hiddenFileInput2.current) {
      hiddenFileInput2.current.value = "";
    }
  };
  const handleClosePreview2 = () => {
    setServicePreview(false);
    setSelectedServicefile(null);
    setSelectedAgents([]);
    if (hiddenFileInput.current) {
      hiddenFileInput.current.value = "";
    }
  };
  const handleCloseTotalcountPreview = () => {
    setTotalCountPreview(false);
  };
  const handleConfirmSalesPreview = (event) => {
    // console.log("selectedAgents", selectedAgents);
    const dataFile = event.target.files[0];
    setSelectedSalesfile(dataFile);
    setSalesPreview(true);
    if (selectedAgents.length > 0 && dataFile) {
      setUploadButton(false);
    } else {
      setUploadButton(true);
    }
  };
  const handleConfirmServerPreview = (event) => {
    const dataFile = event.target.files[0];
    setSelectedServicefile(dataFile);
    setServicePreview(true);
    if (selectedAgents.length > 0 && dataFile) {
      setUploadButton2(false);
    } else {
      setUploadButton2(true);
    }
  };
  const SaleshandleChangeFile = async (file) => {
    if (file) {
      let agent = JSON.stringify(selectedAgents);
      // console.log("agent", agent);
      const dataArray = new FormData();
      dataArray.append("file", file);
      dataArray.append("agentList", agent);
      setSpinner(true);

      try {
        // Make a POST request using Axios
        const res = await axios.post(
          BaseUrl + "/users/createExcelSheetUsers",
          dataArray,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "multipart/form-data",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        );
        if (res.data.success) {
          setTotalSuccessCount(res.data.successCount);
          setTotalErrorCount(res.data.errorCount);


           setErrorFile(excelDownloadUrl+res.data.errorFile)
        
          setTimeout(() => {
            setSpinner(false);
          }, 2000);

          // Call the listSalesreport function
          listSalesreport();

          // Update state variables
          setSalesButton("contained");
          setServiceButton("outlined");
          settableType("Sales");
          settableListType("salesUpload");
          handleClosePreview();
        } else {
          settableType("Sales");
        }
      } catch (error) {
        // Display error toast message
        toast.error("sales excel not uploaded", toaststyle);
      }
    }
  };
  const ServicehandleChangeFile = async (file) => {
    if (file) {
      let agent = JSON.stringify(selectedAgents);

      const dataArray = new FormData();
      dataArray.append("file", file);
      dataArray.append("agentList", agent);
      setSpinner(true);
      try {
        const res = await axios.post(
          BaseUrl + "/users/createExcelServiceUsers",
          dataArray,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("access_token"),
              "Content-Type": "multipart/form-data",
              tenantId: localStorage.getItem("TenantId"),
            },
          }
        );
        settableType("Service");
        setTotalSuccessCount(res.data.successCount);
        setTotalErrorCount(res.data.errorCount);
        console.log("service data")
        if(res.data.errorCount&&res.data.errorCount>0){

          console.log("errorFile",res.data.errorFile)
          setErrorFile(excelDownloadUrl+res.data.errorFile)
          
       }
        setTimeout(() => {
          setSpinner(false);
        }, 2000);
        listServicereport();
        setServiceButton("contained"); // Keep Service button active
        setSalesButton("outlined"); // Set Sales button to outlined
        settableListType("serviceUpload");
        handleClosePreview2();
      } catch (error) {
        toast.success("service excel not uploaded", toaststyle);
      }
    }
  };

  const listSalesreport = async (value) => {
    const currentDate = new Date().toISOString().split("T")[0];
    const isCurrentDate = fromdate === currentDate && todate === currentDate;
    setLoadingSales(true);
    let data = {
      agent_id: Agentid,
      offset: value == null ? 0 : value == 1 ? 0 : (value - 1) * 10,
      limit: 10,
      // from_date: defaultValue ? defaultValue : fromdate,
      // to_date: defaultValue ? defaultValue : todate,
      from_date: tableType == "Sales" ? fromdate : defaultValue,
      to_date: tableType == "Sales" ? todate : defaultValue,
      mobilenumber: mobilenumber,
      brand: brand,
    };
    await axios
      .post(BaseUrl + "/contact/listSupervisorreport", data, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        // console.log("listSalesreport", res);
        if (res.data.status == true) {
          setsupervisorSalesContactList(res.data.data);
          setPagination2(res.data.count);
          setTimeout(() => {
            setLoadingSales(false);
          }, 1000);
        } else {
          setsupervisorSalesContactList([]);
          setPagination2(0);
          setTimeout(() => {
            setLoadingSales(false);
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setTimeout(() => {
          setLoadingSales(false);
        }, 1000);
      });
  };
  const listServicereport = async (value) => {
    setLoadingService(true);
    let body = {
      agent_id: Agentid,
      offset: value == null ? 0 : value == 1 ? 0 : (value - 1) * 10,
      limit: 10,
      // from_date: fromdate ? fromdate : defaultValue,
      // to_date: todate ? todate : defaultValue,
      from_date: tableType == "Service" ? fromdate : defaultValue,
      to_date: tableType == "Service" ? todate : defaultValue,
      // from_date: defaultValue ? defaultValue : fromdate,
      // to_date: defaultValue ? defaultValue : todate,
      mobilenumber: mobilenumber,
      brand: brand,
    };
    await axios
      .post(BaseUrl + "/contact/listSupervisorservicereport", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        // console.log("listServicereport", res);

        if (res.data.status == true) {
          setsupervisorServiceContactList(res.data.data);
          setPagination(res.data.count);
          setTimeout(() => {
            setLoadingService(false);
          }, 1000);
        } else {
          setsupervisorServiceContactList([]);
          setPagination(0);
          setTimeout(() => {
            setLoadingService(false);
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("error", error);
        setTimeout(() => {
          setLoadingService(false);
        }, 1000);
      });
  };
  const agentCallcount = async () => {
    setLoadingAgent(true);
    let body = {
      offset: page3 == 1 ? 0 : (page3 - 1) * 10,
      limit: 10,
    };
    await axios
      .post(BaseUrl + "/contact/callcontactcount", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        // console.log("agentCallcount", res);
        if (res.data.success == true) {
          setagentCount(res.data.Data);
          setPagination3(res.data.count);
          setTimeout(() => {
            setLoadingAgent(false);
          }, 1000);
        } else {
          setagentCount([]);
          setPagination3(0);
          setTimeout(() => {
            setLoadingAgent(false);
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };
  const smsCountReport = () => {
    setLoadingSmsCount(true);
    let body = {
      offset: page == 1 ? 0 : (page - 1) * 10,
      limit: 10,
    };
    axios
      .post(BaseUrl + "/contact/smssendcount", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((res) => {
        if (res.data.success == true) {
          setSmsCountContactList(res.data.Data);
          setPagination4(res.data.count);
          setTimeout(() => {
            setLoadingSmsCount(false);
          }, 1000);
        } else {
          setSmsCountContactList([])
          setPagination4(0);
          setTimeout(() => {
            setLoadingSmsCount(false);
          }, 1000);
        }
      });
  };
  const fetchData = () => {
    if (tableType === "Service") {
      // alert("service1")
      setBrand("");
      setmobilenumber("");
      setAgentid("");
      listServicereport();
      setShowSupervisorfilter(false);
      setSelectedRowIds([])
      setPage(1);
    } else {
      // alert("sales1")
      setBrand("");
      setmobilenumber("");
      setAgentid("");
      listSalesreport();
      setShowSupervisorfilter(false);
      setPage2(1);

    }
  };
  const handleChangeAgent = (event) => {
    setSelectedAgents(event.target.value);
    if (selectedSalesfile && event.target.value.length > 0) {
      setUploadButton(false);
    } else {
      setUploadButton(true);
    }
    if (event.target.value.length > 0) {
      event.target.blur();
    }
  };
  const handleChangeAgent2 = (event) => {
    setSelectedAgents(event.target.value);
    if (selectedServicefile && event.target.value.length > 0) {
      setUploadButton2(false);
    } else {
      setUploadButton2(true);
    }
  };

  const handleChange = (event, value) => {
    // alert("service2")
    listServicereport(value);
    setPage(value);
    setSelectAll(false);
    setSelectAll(selectAllByPage[value] || false);
    
  };
  const handleChange2 = (event, value) => {
    // alert("sales2")
    setPage2(value);
    listSalesreport(value);
    setSelectAllsales(false)
    setSelectAllsales(selectAllByPagesales[value] || false);
  };
  const handleChange3 = (event, value) => {
    // agentCallcount();
    setPage3(value);
  };
  const handleChange4 = (event, value) => {
    // smsCountReport();
    setPage4(value);
  };
  // useEffect(() => {
  //   // alert("service4")
  //   listServicereport();
  // }, [page]);

  // useEffect(() => {
  //   // alert("sales4")

  //   listSalesreport();
  // }, [page2]);

  useEffect(() => {
    agentCallcount();
  }, [page3]);

  useEffect(() => {
    smsCountReport();
  }, [page4]);

  useEffect(() => {
    props.getAvailableAgentList();
  }, [tableType]);

  useEffect(() => {
    setPage2(1);
  }, [tableType]);

  return (
    <>
      <StyledPaper>
        <div className="card Report-card w-100 border-0">
          {/* card-header  */}
          <div
            className="card-header border-0 d-flex align-items-center justify-content-between px-2"
            sx={{ fontWeight: 600, color: "#1473e6" }}
          >
            <div
              className="fw-bold fs-16"
              style={{
                textShadow: "1px 0px 0px #c2c2c27d",
                color: "#0b3363",
              }}
            >
              <Button
                disableElevation
                size="small"
                id="sales-primary-btn"
                variant={ServiceButton}
                onClick={() => {
                  // alert("service3")
                  listServicereport();
                  setShowSupervisorfilter(false);
                  setSalesButton("outlined");
                  setServiceButton("contained");
                  setagentButton("outlined");
                  setSmsButton("outlined");
                  settableType("Service");
                  clearFilterCache();
                  setfilterType("");
                  settableListType("serviceUpload");
                  setPage(1);

                  if (tableType != "Service") {
                    setFromdate(defaultValue);
                    setTodate(defaultValue);
                  }
                  setSelectAll(false)
                  setSelectedRowsByPage({})
                  setSelectAllByPage({})
                  setSelectedRowIds([])

                }}
                className="me-2"
              >
                Service
              </Button>

              <Button
                disableElevation
                size="small"
                id="service-primary-btn"
                variant={SalesButton}
                onClick={() => {
                  // alert("sales3")
                  listSalesreport();
                  setShowSupervisorfilter(false);
                  setSalesButton("contained");
                  setServiceButton("outlined");
                  setagentButton("outlined");
                  setSmsButton("outlined");
                  settableType("Sales");
                  clearFilterCache();
                  setfilterType("");
                  settableListType("salesUpload");
                  setPage2(1);
                  setSelectAllsales(false)
                  setSelectedRowsByPagesales({})
                  setSelectAllByPagesales({})
                  setSelectedRowIdssales([])

                }}
                className="me-2"
              >
                Sales
              </Button>

              <Button
                disableElevation
                size="small"
                id="agent-primary-btn"
                variant={agentButton}
                onClick={() => {
                  setSalesButton("outlined");
                  setServiceButton("outlined");
                  setagentButton("contained");
                  setSmsButton("outlined");
                  settableType("Service");
                  clearFilterCache();
                  setfilterType("Agent");
                  settableListType("agentUpload");
                  agentCallcount();
                  setPage3(1);
                }}
                className="me-2"
              >
                Agent Report
              </Button>

              {/* <Button
                disableElevation
                size="small"
                id="agent-primary-btn"
                variant={smsButton}
                onClick={() => {
                  smsCountReport();
                  setSalesButton("outlined");
                  setServiceButton("outlined");
                  setagentButton("outlined");
                  setSmsButton("contained");
                  settableType("Service");
                  clearFilterCache();
                  setfilterType("Agent");
                  settableListType("smsCount");
                  setPage4(1);
                }}
                className="me-2"
              >
                SMS Send
              </Button> */}
            </div>
            <div>
              <ButtonGroup
                variant="contained"
                aria-label="button group"
                disableElevation
                size="small"
                sx={{
                  textTransform: "capitalize",
                }}
              >
                {/* Service Upload btn  */}

                <Button
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={() => {
                    setShowSupervisorfilter(false);
                    props.getAvailableAgentList();
                    setServicePreview(true);
                  }}
                >
                  <MdOutlineFileUpload className="me-2" />
                  Service Upload
                </Button>

                {/*  Sales Upload btn  */}
                <Button
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={() => {
                    setShowSupervisorfilter(false);
                    setSalesPreview(true);
                    props.getAvailableAgentList();
                  }}
                >
                  <MdOutlineFileUpload className="me-2" />
                  Sales Upload
                </Button>
                {/* Filter btn  */}
                <Button
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={() => {
                    if (filterType == "Agent") {
                      setShowSupervisorAgentreports(true);
                    } else {
                      setShowSupervisorfilter(true);
                      props.getAvailableAgentList();
                    }
                  }}
                >
                  <FunnelSimple className="me-2" />
                  Filter
                </Button>
              </ButtonGroup>
            </div>
          </div>
          {/* card-body */}
          {(() => {
            switch (tableListType) {
              case "serviceUpload":
                return (
                  <>
                    <div
                      className="card-body p-1 vh-71 box-inset"
                      sx={{
                        justifyContent: "center",
                        display: "flex",
                        height: "calc(100% - 40px)",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10",
                      }}
                    >
                      <StyledTableContainer>
                        <StyledTableHead>
                          <StyledTableRow>
                            {!supervisorServiceContactList.length ? (
                              ""
                            ) : (
                              <StyledTableCell style={{ minWidth: "50px" }}>
                                {/* "Select All" checkbox */}
                                <div className="d-flex">

                                <input
                                  type="checkbox"
                                  checked={selectAll}
                                  onChange={handleSelectAll}
                                />
                                {selectAll || selectedRowIds.length ?
                                <DeleteForeverIcon color="error" onClick={handleDeleteAll} className="mx-1" fontSize="medium" style={{fontSize:'16px',cursor:'pointer'}}/>:''
                                }
                                </div>
                              </StyledTableCell>
                            )}
                            {[
                              "Agent Name",
                              "Brand",
                              "Customer Name",
                              "Customer Number",
                              "Registration No",
                              "Model Description",
                              "Chassis No",
                              "Job Card",
                              "Invoice Date",
                              "Location",
                              "Service Advisor",
                              "External Color",
                              "Nature Of Work",
                              "Job Type",
                              "Call Status",
                              "Date",
                              "Timestamp",
                              "Action",
                            ].map((headers) => (
                              <StyledTableCell style={{ minWidth: "150px" }}>
                                {headers}
                              </StyledTableCell>
                            ))}
                          </StyledTableRow>
                        </StyledTableHead>

                        {loadingService ? (
                          <Stack
                            sx={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                            }}
                          >
                            <Hourglass
                              visible={true}
                              height="30"
                              width="30"
                              ariaLabel="hourglass-loading"
                              wrapperStyle={{}}
                              wrapperClass=""
                              colors={["#2268a0", "#72a1ed"]}
                            />
                          </Stack>
                        ) : supervisorServiceContactList.length > 0 ? (
                          supervisorServiceContactList.map(
                            (rowData, rowIndex) => (
                              <StyledTableRow
                                key={rowIndex._id}
                                className="text-break"
                              >
                                <StyledTableCell2>
                                  {/* Individual row checkbox */}
                                  <input
                                    type="checkbox"
                                    // checked={selectedRows.includes(rowData.id)}
                                    checked={(selectedRowsByPage[page] || []).includes(rowData.id)}
                                    onChange={() => handleRowSelect(rowData)}
                                  />
                                   
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.agent_id.username}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.Brand}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.CUST_NAME}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.MOBILE}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.REG_NO}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.Model_Description}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.CHASSIS_NO}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.Job_Card}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.Invoice_Date}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.Location}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.ADVISOR}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.External_Color}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.nature_of_work
                                    ? rowData.nature_of_work
                                    : ""}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.job_type ? rowData.job_type : ""}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.callstatus}
                                </StyledTableCell2>

                                <StyledTableCell2>
                                  {moment(rowData.createdAt).format("L")}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {moment(rowData.createdAt).format("hh:mm A")}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  <DeleteForeverIcon onClick={()=>handleDelete(rowData)}  color="error" style={{fontSize:'18px',cursor:'pointer'}} />
                                </StyledTableCell2>
                              </StyledTableRow>

                              // <div className="card-footer rounded-0 d-flex justify-content-between">
                              //   <div>
                              //     Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                              //     {Math.min(page * 10, pagination)} of {pagination}{" "}
                              //     entries
                              //   </div>
                              //   <Pagination
                              //     count={Math.ceil(pagination / 10)}
                              //     page={page}
                              //     color="primary"
                              //     size="small"
                              //     style={{ float: "right" }}
                              //     onChange={handleChange}
                              //   />
                              // </div>
                            )
                          )
                        ) : (
                          // Data unavailable start
                          <Stack
                            sx={{
                              position: "absolute",
                              width: "100%",
                              height: "calc(100vh - 14rem)",
                            }}
                            justifyContent="center"
                            alignContent="center"
                          >
                            <Stack
                              className="text-muted"
                              direction="column"
                              justifyContent="center"
                              alignContent="center"
                            >
                              <span className="mx-auto">
                                <img
                                  src={Nodata}
                                  alt="pic"
                                  style={{ width: "11rem", userSelect: "none" }}
                                />
                              </span>
                              <span className="mx-auto">
                                <h6
                                  className="text-muted mt-3"
                                  style={{ fontSize: "13px" }}
                                >
                                  Data unavailable
                                </h6>
                              </span>
                            </Stack>
                          </Stack>
                          // Data unavailable end
                        )}
                      </StyledTableContainer>
                    </div>
                    {/* card-footer */}
                    <div className="card-footer border-0">
                      <Box>
                        <Stack
                          sx={{ width: "100%", height: "100%" }}
                          direction={"row"}
                          alignItems={"center"}
                          justifyContent={"space-between"}
                        >
                          {/* Pagination content  */}
                          <Typography
                            variant="caption"
                            sx={{ fontSize: "12px" }}
                          >
                            Showing {Math.min((page - 1) * 10 + 1, pagination)}{" "}
                            to {Math.min(page * 10, pagination)} of {pagination}{" "}
                            entries
                          </Typography>
                          {/* Pagination  */}
                          <Pagination
                            count={Math.ceil(pagination / 10)}
                            page={page}
                            variant="outlined"
                            shape="rounded"
                            color="primary"
                            size="small"
                            style={{ float: "right" }}
                            onChange={handleChange}
                          />
                        </Stack>
                      </Box>
                    </div>
                  </>
                );
              case "salesUpload":
                return (
                  <>
                    <div
                      className="card-body p-1 vh-71 box-inset"
                      sx={{
                        justifyContent: "center",
                        display: "flex",
                        height: "calc(100% - 40px)",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10",
                      }}
                    >
                      <StyledTableContainer>
                        <StyledTableHead>
                          <StyledTableRow>
                            {!supervisorSalesContactList.length ? (
                              ""
                            ) : (
                              <StyledTableCell style={{ minWidth: "50px" }}>
                                {/* "Select All" checkbox */}
                                <div className="d-flex">

                                <input
                                  type="checkbox"
                                  checked={selectAllsales}
                                  onChange={handleSelectAllsales}
                                />
                                {selectAllsales || selectedRowIdssales.length ?
                                <DeleteForeverIcon  onClick={handleDeleteAllsales}  color="error" style={{fontSize:'16px',cursor:'pointer'}} />
                                :''
                                }
                                </div>
                              </StyledTableCell>
                              
                              
                            )}
                            {[
                               
                              "Agent Name",
                              "Delivery Date",
                               "Call Status",
                              "Brand",
                              "Customer Name",
                              "Customer Number",
                             
                              "Customer Email",
                              "Address",
                              "Model Description",
                              "Chassis No",
                              "Year",
                              "Month",
                              "Invoice No",
                              "Invoice Date	",
                              "Location",
                              "Salesman",
                              "CustomerCategory",
                              "Invoice Branch",
                             
                              "Date",
                              "Timestamp",
                              "Action"
                            ].map((headers) => (
                              <StyledTableCell style={{ minWidth: "150px" }}>
                                {headers}
                              </StyledTableCell>
                            ))}
                          </StyledTableRow>
                        </StyledTableHead>
                        {loadingService ? (
                          <Stack
                            sx={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                            }}
                          >
                            <Hourglass
                              visible={true}
                              height="30"
                              width="30"
                              ariaLabel="hourglass-loading"
                              wrapperStyle={{}}
                              wrapperClass=""
                              colors={["#2268a0", "#72a1ed"]}
                            />
                          </Stack>
                        ) : supervisorSalesContactList.length > 0 ? (
                          supervisorSalesContactList.map(
                            (rowData, rowIndex) => (
                              <StyledTableRow
                                key={rowIndex._id}
                                className="text-break"
                              >
                                <StyledTableCell2>
                                  {/* Individual row checkbox */}
                                  <input
                                    type="checkbox"
                                    // checked={selectedRowssales.includes(
                                    //   rowData.id
                                    // )}
                                    checked={(selectedRowsByPagesales[page2] || []).includes(rowData.id)}
                                    onChange={() =>
                                      handleRowSelectsales(rowData)
                                    }
                                  />
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.agent_id.username}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.Delivery_Date}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.callstatus}
                                </StyledTableCell2>
                              
                                <StyledTableCell2>
                                  {rowData.Brand}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.Customer_Name}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.Mobile}
                                </StyledTableCell2>
                                
                                <StyledTableCell2>
                                  {rowData.Email}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.Address2}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.Model_Description}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.Chassis_No}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.Year}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.month ? rowData.month : ""}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.Invoice_No}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.Inv_Date}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.Location}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.Salesman}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {rowData.Customer_Category}
                                </StyledTableCell2>

                                <StyledTableCell2>
                                  {rowData.Inv_Brch}
                                </StyledTableCell2>

                              
                                <StyledTableCell2>
                                  {moment(rowData.createdAt).format("L")}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                  {moment(rowData.createdAt).format("hh:mm A")}
                                </StyledTableCell2>
                                <StyledTableCell2>
                                <DeleteForeverIcon onClick={()=>handleDeletesales(rowData)}  color="error" style={{fontSize:'18px',cursor:'pointer'}} />
                                </StyledTableCell2>
                              </StyledTableRow>

                              // <div className="card-footer rounded-0 d-flex justify-content-between">
                              //   <div>
                              //     Showing {Math.min((page - 1) * 10 + 1, pagination)} to{" "}
                              //     {Math.min(page * 10, pagination)} of {pagination}{" "}
                              //     entries
                              //   </div>
                              //   <Pagination
                              //     count={Math.ceil(pagination / 10)}
                              //     page={page}
                              //     color="primary"
                              //     size="small"
                              //     style={{ float: "right" }}
                              //     onChange={handleChange}
                              //   />
                              // </div>
                            )
                          )
                        ) : (
                          // Data unavailable start
                          <Stack
                            sx={{
                              position: "absolute",
                              width: "100%",
                              height: "calc(100vh - 14rem)",
                            }}
                            justifyContent="center"
                            alignContent="center"
                          >
                            <Stack
                              className="text-muted"
                              direction="column"
                              justifyContent="center"
                              alignContent="center"
                            >
                              <span className="mx-auto">
                                <img
                                  src={Nodata}
                                  alt="pic"
                                  style={{ width: "11rem", userSelect: "none" }}
                                />
                              </span>
                              <span className="mx-auto">
                                <h6
                                  className="text-muted mt-3"
                                  style={{ fontSize: "13px" }}
                                >
                                  Data unavailable
                                </h6>
                              </span>
                            </Stack>
                          </Stack>
                          // Data unavailable end
                        )}
                      </StyledTableContainer>
                    </div>
                    {/* card-footer */}
                    <div className="card-footer border-0">
                      <Box>
                        <Stack
                          sx={{ width: "100%", height: "100%" }}
                          direction={"row"}
                          alignItems={"center"}
                          justifyContent={"space-between"}
                        >
                          {/* Pagination content  */}
                          <Typography
                            variant="caption"
                            sx={{ fontSize: "12px" }}
                          >
                            Showing{" "}
                            {Math.min((page2 - 1) * 10 + 1, pagination2)} to{" "}
                            {Math.min(page2 * 10, pagination2)} of {pagination2}{" "}
                            entries
                          </Typography>
                          {/* Pagination  */}
                          <Pagination
                            count={Math.ceil(pagination2 / 10)}
                            page={page2}
                            variant="outlined"
                            shape="rounded"
                            color="primary"
                            size="small"
                            style={{ float: "right" }}
                            onChange={handleChange2}
                          />
                        </Stack>
                      </Box>
                    </div>
                  </>
                );
              case "agentUpload":
                return (
                <>
                    <div
                      className="card-body p-1 vh-71 box-inset"
                      sx={{
                        justifyContent: "center",
                        display: "flex",
                        height: "calc(100% - 40px)",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10",
                      }}
                    >
                      <StyledTableContainer>
                        <StyledTableHead>
                          <StyledTableRow>
                            {[
                              "Agent Name",
                              "Total Call Assign To Agent",
                              "Completed",
                              "Pending",
                            ].map((headers) => (
                              <StyledTableCell style={{ minWidth: "299px" }}>
                                {headers}
                              </StyledTableCell>
                            ))}
                          </StyledTableRow>
                        </StyledTableHead>
                        {loadingService ? (
                          <Stack
                            sx={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                            }}
                          >
                            <Hourglass
                              visible={true}
                              height="30"
                              width="30"
                              ariaLabel="hourglass-loading"
                              wrapperStyle={{}}
                              wrapperClass=""
                              colors={["#2268a0", "#72a1ed"]}
                            />
                          </Stack>
                        ) : agentCount.length > 0 ? (
                          agentCount.map((rowData, rowIndex) => (
                            <StyledTableRow
                              key={rowIndex._id}
                              className="text-break"
                            >
                              <StyledTableCell2>
                                {rowData.users.username}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {rowData.total}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {rowData.totalcompletecall}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {rowData.totalpendingcall}
                              </StyledTableCell2>
                            </StyledTableRow>
                          ))
                        ) : (
                          // Data unavailable start
                          <Stack
                            sx={{
                              position: "absolute",
                              width: "100%",
                              height: "calc(100vh - 14rem)",
                            }}
                            justifyContent="center"
                            alignContent="center"
                          >
                            <Stack
                              className="text-muted"
                              direction="column"
                              justifyContent="center"
                              alignContent="center"
                            >
                              <span className="mx-auto">
                                <img
                                  src={Nodata}
                                  alt="pic"
                                  style={{ width: "11rem", userSelect: "none" }}
                                />
                              </span>
                              <span className="mx-auto">
                                <h6
                                  className="text-muted mt-3"
                                  style={{ fontSize: "13px" }}
                                >
                                  Data unavailable
                                </h6>
                              </span>
                            </Stack>
                          </Stack>
                          // Data unavailable end
                        )}
                      </StyledTableContainer>
                    </div>
                    {/* card-footer */}
                    <div className="card-footer border-0">
                      <Box>
                        <Stack
                          sx={{ width: "100%", height: "100%" }}
                          direction={"row"}
                          alignItems={"center"}
                          justifyContent={"space-between"}
                        >
                          {/* Pagination content  */}
                          <Typography
                            variant="caption"
                            sx={{ fontSize: "12px" }}
                          >
                            Showing{" "}
                            {Math.min((page3 - 1) * 10 + 1, pagination3)} to{" "}
                            {Math.min(page3 * 10, pagination3)} of {pagination3}{" "}
                            entries
                          </Typography>
                          {/* Pagination  */}
                          <Pagination
                            count={Math.ceil(pagination3 / 10)}
                            page={page3}
                            variant="outlined"
                            shape="rounded"
                            color="primary"
                            size="small"
                            style={{ float: "right" }}
                            onChange={handleChange3}
                          />
                        </Stack>
                      </Box>
                    </div>
                </>
             
                );
              case "smsCount":
                return (
                  <Box>
                    <div
                      className="card-body p-1 vh-71 box-inset"
                      sx={{
                        justifyContent: "center",
                        display: "flex",
                        height: "calc(100% - 40px)",
                        display: "flex",
                        flexDirection: "column",
                        gap: "10",
                      }}
                    >
                      <StyledTableContainer>
                        <StyledTableHead>
                          <StyledTableRow>
                            {[
                              "Agent Name",
                              "Total SMS Count",
                              "Completed",
                              "Pending",
                            ].map((headers) => (
                              <StyledTableCell style={{ minWidth: "299px" }}>
                                {headers}
                              </StyledTableCell>
                            ))}
                          </StyledTableRow>
                        </StyledTableHead>
                        {loadingService ? (
                          <Stack
                            sx={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                            }}
                          >
                            <Hourglass
                              visible={true}
                              height="30"
                              width="30"
                              ariaLabel="hourglass-loading"
                              wrapperStyle={{}}
                              wrapperClass=""
                              colors={["#2268a0", "#72a1ed"]}
                            />
                          </Stack>
                        ) : smsCountContactList.length > 0 ? (
                          smsCountContactList.map((rowData, rowIndex) => (
                            <StyledTableRow
                              key={rowIndex._id}
                              className="text-break"
                            >
                              <StyledTableCell2>
                                {rowData.users.username == null ||
                                rowData.users.username == undefined ||
                                rowData.users.username == ""
                                  ? "--"
                                  : rowData.users.username}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {rowData.total}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {rowData.totalcompletecall}
                              </StyledTableCell2>
                              <StyledTableCell2>
                                {rowData.totalpendingcall}
                              </StyledTableCell2>
                            </StyledTableRow>
                          ))
                        ) : (
                          // Data unavailable start
                          <Stack
                            sx={{
                              position: "absolute",
                              width: "100%",
                              height: "calc(100vh - 14rem)",
                            }}
                            justifyContent="center"
                            alignContent="center"
                          >
                            <Stack
                              className="text-muted"
                              direction="column"
                              justifyContent="center"
                              alignContent="center"
                            >
                              <span className="mx-auto">
                                <img
                                  src={Nodata}
                                  alt="pic"
                                  style={{ width: "11rem", userSelect: "none" }}
                                />
                              </span>
                              <span className="mx-auto">
                                <h6
                                  className="text-muted mt-3"
                                  style={{ fontSize: "13px" }}
                                >
                                  Data unavailable
                                </h6>
                              </span>
                            </Stack>
                          </Stack>
                          // Data unavailable end
                        )}
                      </StyledTableContainer>
                    </div>
                    {/* card-footer */}
                    <div className="card-footer border-0">
                      <Box>
                        <Stack
                          sx={{ width: "100%", height: "100%" }}
                          direction={"row"}
                          alignItems={"center"}
                          justifyContent={"space-between"}
                        >
                          {/* Pagination content  */}
                          <Typography
                            variant="caption"
                            sx={{ fontSize: "12px" }}
                          >
                            Showing {Math.min((page - 1) * 10 + 1, pagination)}{" "}
                            to {Math.min(page * 10, pagination)} of {pagination}{" "}
                            entries
                          </Typography>
                          {/* Pagination  */}
                          <Pagination
                            count={Math.ceil(pagination4 / 10)}
                            page={page4}
                            variant="outlined"
                            shape="rounded"
                            color="primary"
                            size="small"
                            style={{ float: "right" }}
                            onChange={handleChange4}
                          />
                        </Stack>
                      </Box>
                    </div>
                  </Box>
                );
              default:
                return <></>;
            }
          })()}
        </div>
      </StyledPaper>

      {/* <SupervisorContactfilter
        showSupervisorfilter={showSupervisorfilter}
        setShowSupervisorfilter={setShowSupervisorfilter}
        SupervisorAgentName={SupervisorAgentName}
        setFromdate={setFromdate}
        setTodate={setTodate}
        fromdate={fromdate}
        todate={todate}
        mobilenumber={mobilenumber}
        setmobilenumber={setmobilenumber}
        setAgentid={setAgentid}
        fetchData={fetchData}
        clearFilter={clearFilter}
      />

      <SupervisorAgentreports
        showSupervisorAgentreports={showSupervisorAgentreports}
        setShowSupervisorAgentreports={setShowSupervisorAgentreports}
      /> */}

      <Dialog
        open={fileuploadPopup}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          variant="subtitle2"
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            color: "#0b3363",
            boxShadow:
              "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
          }}
        >
          File Upload
        </DialogTitle>
        <DialogContent>
          <Box className="mt-3">
            <DialogContentText id="alert-dialog-slide-description">
              <Stack>{file ? file.name : file}</Stack>
            </DialogContentText>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            variant="outlined"
            color="error"
            size="small"
            sx={{ textTransform: "capitalize !important" }}
          >
            Close
          </Button>
          <Button
            variant="contained"
            onClick={() => {
              UploadFile();
            }}
            disabled={uploadButton}
            disableElevation
            size="small"
            sx={{ textTransform: "capitalize !important" }}
          >
            Upload
          </Button>
        </DialogActions>
      </Dialog>
      {/* Sales Upload start  */}
      <Dialog
        open={Salespreview}
        keepMounted
        onClose={handleClosePreview}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          variant="subtitle2"
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            color: "#0b3363",
            boxShadow:
              "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
          }}
        >
          Sales Upload
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <Box className="mt-3">
              <Stack direction={"row"} alignItems={"center"} spacing={1}>
                <Button
                  variant="contained"
                  id="file-btn"
                  endIcon={<DownloadSimple size={15} />}
                  onClick={() => {
                    SaleshandleClick2();
                  }}
                  disableElevation
                >
                  Choose file
                  <input
                    type="file"
                    ref={hiddenFileInput2}
                    onChange={(event) => {
                      handleConfirmSalesPreview(event);
                    }}
                    style={{ display: "none" }}
                  />
                </Button>

                <Box>
                  <FormControl sx={{ m: 1, width: 300 }} size="small">
                    <InputLabel id="demo-multiple-name-label">
                      Select Agent
                    </InputLabel>
                    <Select
                      size="small"
                      labelId="demo-multiple-name-label"
                      id="demo-multiple-name"
                      multiple
                      value={selectedAgents} // Make sure selectedAgents is an array
                      onChange={handleChangeAgent} // Provide a function to handle changes
                      input={<OutlinedInput label="Select Agent" />}
                      MenuProps={{
                        style: {
                          top: "0px",
                          maxHeight: "350px",
                        },
                      }}
                    >
                      {props.DropDownAgentList.length > 0 ? (
                        props.DropDownAgentList.map((Agent) => (
                          <MenuItem value={Agent.id} key={Agent.id}>
                            {Agent.username}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem>{"No Data"}</MenuItem>
                      )}
                    </Select>
                  </FormControl>
                </Box>
              </Stack>
              <Stack>
                <label
                  htmlFor="formFileSm"
                  className="form-label col-form-label-sm"
                >
                  <div style={{ fontSize: "12px" }}>
                    {" "}
                    {selectedSalesfile ? selectedSalesfile.name : ""}
                  </div>

                  <p>
                    Please Download Sample Sheet{" "}
                    <a href={excelDownloadUrl + "/uploads/salessample.xlsx"}>
                      Link
                    </a>{" "}
                    Here
                  </p>
                </label>
              </Stack>
            </Box>
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleClosePreview}
            variant="outlined"
            color="error"
            size="small"
            sx={{ textTransform: "capitalize !important" }}
          >
            Close
          </Button>
          {spinner ? (
            <span
              className="spinner-border spinner-border-sm text-primary"
              role="status"
              aria-hidden="true"
              style={{
                flexDirection: "column",
                marginTop: "20%",
                display: "flex",
                position: "absolute",
                left: "45%",
                bottom: "30%",
              }}
            ></span>
          ) : (
            <Button
              variant="contained"
              onClick={() => {
                if (selectedSalesfile) {
                  SaleshandleChangeFile(selectedSalesfile);
                  setSelectedSalesfile(null);
                }
                setTotalCountPreview(true);
              }}
              disabled={uploadButton}
              disableElevation
              size="small"
              sx={{ textTransform: "capitalize !important" }}
            >
              Upload
            </Button>
          )}
        </DialogActions>
      </Dialog>
      {/* Sales Upload end  */}
      {/* SERVICEMODAL */}
      <Dialog
        open={Servicepreview}
        keepMounted
        onClose={handleClosePreview2}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          variant="subtitle2"
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            color: "#0b3363",
            boxShadow:
              "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
          }}
        >
          Service Upload
        </DialogTitle>
        <DialogContent>
          <Box className="mt-3">
            <Stack direction={"row"} alignItems={"center"} spacing={1}>
              <Button
                disableElevation
                variant="contained"
                id="file-btn"
                endIcon={<DownloadSimple size={15} />}
                onClick={() => {
                  ServicehandleClick();
                }}
              >
                Choose file
                <input
                  type="file"
                  ref={hiddenFileInput}
                  onChange={handleConfirmServerPreview}
                  style={{ display: "none" }}
                />
              </Button>
              <Box sx={{ width: "320px" }}>
                <FormControl sx={{ m: 1, width: 300 }} size="small">
                  <InputLabel id="demo-multiple-name-label">
                    Select Agent
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-name-label"
                    id="demo-multiple-name"
                    multiple
                    value={selectedAgents} // Make sure selectedAgents is an array
                    onChange={handleChangeAgent2} // Provide a function to handle changes
                    input={<OutlinedInput label="Select Agent" />}
                    MenuProps={{
                      style: {
                        top: "0px",
                        maxHeight: "350px",
                      },
                    }}
                  >
                    {props.DropDownAgentList.length > 0 ? (
                      props.DropDownAgentList.map((Agent) => (
                        <MenuItem value={Agent.id} key={Agent.id}>
                          {Agent.username}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem>{"No Data"}</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Box>
            </Stack>
            <Stack spacing={0.5} sx={{ height: "40px", width: "450px" }}>
              <label for="formFileSm" className="form-label col-form-label-sm">
                <div style={{ fontSize: "12px" }}>
                  {" "}
                  {selectedServicefile ? selectedServicefile.name : ""}
                </div>

                <p>
                  Please Download Sample Sheet{" "}
                  <a href={excelDownloadUrl + "/uploads/servicesample.xlsx"}>
                    Link
                  </a>{" "}
                  Here
                </p>
              </label>
            </Stack>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleClosePreview2}
            variant="outlined"
            color="error"
            size="small"
            sx={{ textTransform: "capitalize !important" }}
          >
            Close
          </Button>
          {spinner ? (
            <span
              className="spinner-border spinner-border-sm text-primary"
              role="status"
              aria-hidden="true"
              style={{
                flexDirection: "column",
                marginTop: "20%",
                display: "flex",
                position: "absolute",
                left: "45%",
                bottom: "30%",
              }}
            ></span>
          ) : (
            <Button
              variant="contained"
              onClick={() => {
                if (selectedServicefile) {
                  ServicehandleChangeFile(selectedServicefile);
                  setSelectedServicefile(null);
                }
                setTotalCountPreview(true);
              }}
              disabled={uploadButton2}
              disableElevation
              size="small"
              sx={{ textTransform: "capitalize !important" }}
            >
              Upload
            </Button>
          )}
        </DialogActions>
      </Dialog>
      {/* Sales Upload end  */}
      {/* TOTALCOUNTMODAL */}
      <Dialog
        open={totalCountPreview}
        keepMounted
        onClose={handleClosePreview}
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle
          variant="subtitle2"
          sx={{
            fontSize: "16px",
            fontWeight: 600,
            color: "#0b3363",
            boxShadow:
              "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
          }}
        >
          Total Count
        </DialogTitle>
        <DialogContent>
          <Stack direction={"row"} alignItems={"center"} spacing={1}>
            <Box className="mt-3">
              <FormControl sx={{ m: 1, width: 300 }} size="small">
                Total SuccessCount: {totalSuccessCount}
              </FormControl>
              <FormControl sx={{ m: 1, width: 300 }} size="small">
                Total ErrorCount: {totalErrorCount}
              </FormControl>
              {totalErrorCount > 0 && (
      <FormControl sx={{ m: 1, width: 300 }} size="small">
        <Box display="flex" alignItems="center">
        Please Download  Error File&nbsp;<a href={errorFile}>Link</a>{" "}
        Here
        </Box>
      </FormControl> )}
            </Box>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleCloseTotalcountPreview();
            }}
            variant="outlined"
            color="error"
            size="small"
            sx={{ textTransform: "capitalize !important" }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
      {/* Filters Drawer Start  */}
      {/* service ,sale filter */}
      <Drawer
        anchor="right"
        open={showSupervisorfilter}
        onClose={() => {
          setShowSupervisorfilter(false);
        }}
      >
        <Box style={{ width: "20rem" }}>
          {/* Drawer head start */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="p-3 shadowDrawer"
          >
            <Typography variant="h3" gutterBottom className="drawer-title">
              Filters
            </Typography>
          </Stack>
          {/* Drawer head end */}
          {/* Drawer Content start */}
          <Stack
            className="p-3"
            style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
          >
            <form className="fs-13">
              <div className="custom_div">
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="fromdate" className="form-label">
                    From
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    value={fromdate}
                    onChange={(e) => setFromdate(e.target.value)}
                    max={defaultValue}
                  />
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="todate" className="form-label">
                    To
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    value={todate}
                    onChange={(e) => setTodate(e.target.value)}
                    max={defaultValue}
                  />
                  {!isToDateValid() && (
                    <span
                      className="text-danger fw-bold"
                      style={{ fontSize: "10px" }}
                    >
                      To Date cannot be less than From Date*
                    </span>
                  )}
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="mobilenumber" className="form-label">
                    Enter Mobile Number
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id=""
                    aria-describedby="number"
                    value={props.mobilenumber}
                    onChange={(e) => setmobilenumber(e.target.value)}
                  />
                </div>

                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="mobilenumber" className="form-label">
                    Enter Brand
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => setBrand(e.target.value)}
                    value={brand}
                  >
                    <option value="">Select Brand</option>
                    <option value="Mazda">Mazda</option>
                    <option value="Mahindra">Mahindra</option>
                    <option value="Preowned">Preowned</option>
                    <option value="Ziebart">Ziebart</option>
                    <option value="Powersport">Powersport</option>
                    <option value="CarBody Worx">CarBody Worx</option>
                    <option value="Rent A Car">Rent A Car</option>
                  </select>
                </div>

                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="todate" className="form-label">
                    Select Agent
                  </label>
                  <select
                    className="form-select"
                    aria-label="Default select example"
                    onChange={(e) => setAgentid(e.target.value)}
                  >
                    <option value="">Select Agent Name</option>

                    {props.DropDownAgentList.length > 0 &&
                      props.DropDownAgentList.map((item) => {
                        return (
                          <option value={item.id} key={item.id}>
                            {item.username}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </div>
            </form>
          </Stack>
          {/* Drawer Content end */}
          {/* Drawer footer start */}
          <Stack
            className="p-2"
            sx={{
              position: "absolute",
              bottom: "0",
              background: "#f9f9f9",
              width: "100%",
              boxShadow:
                "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
            }}
            direction="row"
            justifyContent="space-between"
            alignContent="center"
          >
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="error"
              disableElevation
              onClick={() => {
                setShowSupervisorfilter(false);
              }}
            >
              Close
            </Button>
            <Button
              className="w-100"
              variant="contained"
              disableElevation
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              id="session_filter_Submit"
              onClick={fetchData}
            >
              Submit
            </Button>
          </Stack>
          {/* Drawer footer end */}
        </Box>
      </Drawer>
      {/* sms , agent ,Drawer For Agent Report filter */}
      <Drawer
        anchor="right"
        open={showSupervisorAgentreports}
        onClose={() => {
          setShowSupervisorAgentreports(false);
        }}
      >
        <Box style={{ width: "20rem" }}>
          {/* Drawer head start */}
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="p-3 shadowDrawer"
          >
            <Typography variant="h3" gutterBottom className="drawer-title">
              Filters
            </Typography>
          </Stack>
          {/* Drawer head end */}
          {/* Drawer Content start */}
          <Stack
            className="p-3"
            style={{ height: "calc(100vh - 7rem)", overflowY: "scroll" }}
          >
            <form className="fs-13">
              <div className="custom_div">
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="fromdate" className="form-label">
                    From
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    value={fromdate}
                    onChange={(e) => setFromdate(e.target.value)}
                    max={defaultValue}
                  />
                </div>
                <div className="mb-3 d-flex flex-column text-start">
                  <label htmlFor="todate" className="form-label">
                    To
                  </label>
                  <input
                    type="date"
                    className="form-control"
                    id=""
                    aria-describedby="date"
                    value={todate}
                    onChange={(e) => setTodate(e.target.value)}
                    max={defaultValue}
                  />
                  {!isToDateValid() && (
                    <span
                      className="text-danger fw-bold"
                      style={{ fontSize: "10px" }}
                    >
                      To Date cannot be less than From Date*
                    </span>
                  )}
                </div>
              </div>
            </form>
          </Stack>
          {/* Drawer Content end */}
          {/* Drawer footer start */}
          <Stack
            className="p-2"
            sx={{
              position: "absolute",
              bottom: "0",
              background: "#f9f9f9",
              width: "100%",
              boxShadow:
                "rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px, rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px",
            }}
            direction="row"
            justifyContent="space-between"
            alignContent="center"
          >
            <Button
              variant="contained"
              className="me-2 w-100"
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              color="error"
              disableElevation
              onClick={() => {
                setShowSupervisorAgentreports(false);
              }}
            >
              Close
            </Button>
            <Button
              className="w-100"
              variant="contained"
              disableElevation
              sx={{
                textShadow: "0 1px 0 rgba(0, 0, 0, .4)",
                textTransform: "Capitalize",
              }}
              id="session_filter_Submit"
              onClick={fetchData}
            >
              Submit
            </Button>
          </Stack>
          {/* Drawer footer end */}
        </Box>
      </Drawer>
      {/* Filters Drawer end  */}
    </>
  );
};

export default connect(mapStateToProps, {
  getAvailableAgentList,
})(SupervisorContact);
